import { FullProduct } from "ts/api/product";

const separateProductsWithApproval = (products: FullProduct[]) =>
  products.reduce<{
    productsWithApproval: FullProduct[];
    productsWithoutApproval: FullProduct[];
  }>(
    (acc, cur) => {
      if (!cur.approval) {
        acc.productsWithoutApproval.push(cur);
        return acc;
      }
      acc.productsWithApproval.push(cur);
      return acc;
    },
    { productsWithApproval: [], productsWithoutApproval: [] }
  );

export default separateProductsWithApproval;
